import { render, staticRenderFns } from "./DrawStroke.vue?vue&type=template&id=4c942fb0&scoped=true&lang=pug&"
import script from "./DrawStroke.vue?vue&type=script&lang=ts&"
export * from "./DrawStroke.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c942fb0",
  null
  
)

export default component.exports